import { stringify as qsStringify } from 'query-string';
import type {
	CmdbObjectTypeId,
	ObjectTypeAttributeId,
	WorkspaceId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { ObjectTypeAttributeOptionsRequest } from '../types/object-type-attribute.tsx';
import { getCmdbRestBaseUrl } from './index.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/${objectTypeAttributeId}
 */
export const getCmdbObjectTypeAttributeUrl = (
	workspaceId: WorkspaceId,
	objectTypeAttributeId: ObjectTypeAttributeId,
) => `${getCmdbRestBaseUrl(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/${objectTypeAttributeId}
 */
export const getCmdbObjectTypeAttributeConfigureUrl = (
	workspaceId: WorkspaceId,
	objectTypeAttributeId: ObjectTypeAttributeId,
) => `${getCmdbRestBaseUrl(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/configure`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}
 */
export const getCmdbObjectTypeAttributeUpdateUrl = (
	workspaceId: WorkspaceId,
	objectTypeId: CmdbObjectTypeId,
	objectTypeAttributeId: ObjectTypeAttributeId,
) =>
	`${getCmdbRestBaseUrl(workspaceId)}/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}/move
 */
export const getCmdbObjectTypeAttributeMoveUrl = (
	workspaceId: WorkspaceId,
	objectTypeId: CmdbObjectTypeId,
	objectTypeAttributeId: ObjectTypeAttributeId,
) =>
	`${getCmdbRestBaseUrl(
		workspaceId,
	)}/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}/move`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/${objectTypeAttributeId}/options
 */
export const getCmdbObjectTypeAttributeOptionsUrl = (
	workspaceId: WorkspaceId,
	objectTypeAttributeId: ObjectTypeAttributeId,
	queryParams: ObjectTypeAttributeOptionsRequest,
) =>
	`${getCmdbObjectTypeAttributeUrl(workspaceId, objectTypeAttributeId)}/options?${qsStringify(
		queryParams,
	)}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttypeattribute/parentimport/${objectTypeId}
 */
export const getCmdbObjectTypeAttributeParentImportUrl = (
	workspaceId: WorkspaceId,
	objectTypeId: CmdbObjectTypeId,
) => `${getCmdbRestBaseUrl(workspaceId)}/objecttypeattribute/parentimport/${objectTypeId}`;
